/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _widget = __webpack_require__(198);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!window._FUTURI_WIDGET) {
	  window._FUTURI_WIDGET = true;
	
	  window.FUTURI_WIDGETS = [];
	
	  var scriptElementsWithQuery = [].slice.call(document.querySelectorAll('script[src*="futuri-post-widget"]')).filter(function (el) {
	    return !!el.src.split(/\?/)[1];
	  });
	
	  var anchorElementWithId = document.getElementById('futuri-widget');
	
	  if (scriptElementsWithQuery[0]) {
	    var config = scriptElementsWithQuery[0].src.split(/\?/)[1];
	
	    if (anchorElementWithId) {
	      anchorElementWithId.classList.add('futuri-widget');
	      anchorElementWithId.dataset.config = config;
	    } else {
	      var newAnchorElement = document.createElement('div');
	      newAnchorElement.classList.add('futuri-widget');
	      newAnchorElement.dataset.config = config;
	      var parentNode = scriptElementsWithQuery[0].parentNode;
	      parentNode.insertBefore(newAnchorElement, scriptElementsWithQuery[0]);
	    }
	  }
	
	  var anchorElementsWithClass = [].slice.call(document.getElementsByClassName('futuri-widget')).filter(function (el) {
	    return !!el.dataset.config;
	  });
	
	  anchorElementsWithClass.forEach(function (el) {
	    var uuid = 'xxxxxxxxxxx'.replace(/x/g, function () {
	      return Math.floor(Math.random() * 10);
	    });
	    window.FUTURI_WIDGETS.push(new _widget2.default(el, uuid));
	  });
	
	  window.FUTURI_WIDGETS.forEach(function (widget) {
	    if (!widget.hasExecuted) {
	      widget.setupWidget();
	    }
	  });
	}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(18);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(26), __esModule: true };

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(6);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(15);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Widget = function () {
	  function Widget(el, uuid) {
	    (0, _classCallCheck3.default)(this, Widget);
	
	    this.el = el;
	    this.uuid = uuid;
	    this.hasExecuted = false;
	  }
	
	  (0, _createClass3.default)(Widget, [{
	    key: 'formatUrlForIframe',
	    value: function formatUrlForIframe(url) {
	      var qs = document.location.search;
	
	      var formattedURL = url.replace('futuri-post-widget.js', 'futuri-post-widget.html');
	
	      if (qs.length > 1) {
	        if (formattedURL.indexOf('?') > 0) {
	          formattedURL += qs.replace('?', '&');
	        } else {
	          formattedURL += qs;
	        }
	      }
	
	      if (formattedURL.indexOf('?') > 0) {
	        formattedURL += '&';
	      } else {
	        formattedURL += '?';
	      }
	
	      formattedURL += 'src=' + encodeURIComponent(document.location.href);
	
	      if (formattedURL.indexOf('smc') < 0 && formattedURL.indexOf('zone') >= 0) {
	        var smc = /zone=(\d+)/.exec(formattedURL);
	        formattedURL += '&smc=' + smc[1];
	      }
	
	      return formattedURL;
	    }
	  }, {
	    key: 'getNewIframeElement',
	    value: function getNewIframeElement(parentElement, options) {
	      var _this = this;
	
	      var iframeElement = document.createElement('iframe');
	
	      iframeElement.setAttribute('style', 'border: 0; padding: 0; margin: 0;');
	      iframeElement.setAttribute('scrolling', 'no');
	
	      var width = 0;
	      var height = 0;
	
	      if (options.vertical && (options.vertical === 'True' || options.vertical === 'true')) {
	        width = 320;
	        height = 500;
	      } else {
	        if (options.full && (options.full === 'True' || options.full === 'true')) {
	          width = Math.min(700, parentElement.offsetWidth);
	          height = 624;
	        } else {
	          width = Math.min(700, parentElement.offsetWidth);
	          height = 224;
	        }
	      }
	
	      iframeElement.style.borderRadius = '5px';
	
	      if (parentElement.offsetHeight > 50) {
	        iframeElement.height = parentElement.offsetHeight;
	      }
	
	      window.addEventListener('resize', function () {
	        iframeElement.width = Math.min(width, iframeElement.parentElement.offsetWidth);
	      }, false);
	
	      iframeElement.width = width;
	      iframeElement.height = height;
	
	      window.addEventListener('message', function (ev) {
	        try {
	          var msg = JSON.parse(ev.data);
	          if (msg && msg.type === 'resize' && msg.id === _this.uuid) {
	            iframeElement.height = msg.height;
	            iframeElement.width = msg.width;
	          }
	        } catch (e) {}
	      });
	
	      return iframeElement;
	    }
	  }, {
	    key: 'handleIframe',
	    value: function handleIframe() {
	      var scriptTag = document.querySelector('script[src*="futuri-post-widget"]');
	      var urlPrefix = scriptTag.src.split('?')[0];
	      var query = this.el.dataset.config;
	      var url = this.formatUrlForIframe(urlPrefix + '?' + query);
	      var options = Object.fromEntries(new URLSearchParams(url).entries());
	      var iframeElement = this.getNewIframeElement(this.el, options);
	      iframeElement.src = url;
	      iframeElement.name = this.uuid;
	      iframeElement.allow = 'clipboard-write';
	      this.el.appendChild(iframeElement);
	    }
	  }, {
	    key: 'setupWidget',
	    value: function setupWidget() {
	      this.handleIframe();
	      this.hasExecuted = true;
	    }
	  }]);
	  return Widget;
	}();
	
	exports.default = Widget;

/***/ })

/******/ });


// WEBPACK FOOTER //
// static/futuri-post-widget.js